<template>
   <animated-number
      :value="value"
      :formatValue="formatToPrice"
      :duration="3000"
  />
</template>

<script>
   export default {
      props: ["value"],
      methods: {
         formatToPrice(value) {
            return value.toFixed(1) + '%';
         }
      }
   };
</script>
